import React, { Component } from 'react';
import ReactPlayer from 'react-player';
import '@babel/polyfill';
import ReactGA from 'react-ga';
import {
  FacebookShareButton,
  FacebookIcon,
  TwitterShareButton,
  TwitterIcon,
  WhatsappShareButton,
  WhatsappIcon
} from 'react-share';
import { Container, Video, Tickbox, Button, Overlay, Holder, Footer, Message, ShareContainer } from './styles';

class VideoContainer extends Component {
  constructor() {
    super();

    this.total = 0;
    this.state = {
      currentLabel: 'intro',
      hasTriggered: true,
      paused: true,
      ended: false,
      loaded: true,
      percent: 0,
      total: 0,
      showOptions: false,
      showPlayButton: true,
      videoData: [
        {
          label: 'intro',
          url: './video/bintro.mp4',
          options: [
            { x: '7.4%', y: '12%', tickX: '6%', tickY: '11%', w: '57%', h: '17%', angle: '-2deg', label: 'b1' },
            { x: '7.4%', y: '36%', tickX: '6%', tickY: '14%', w: '63%', h: '15%', angle: '-2deg', label: 'b2' },
            { x: '7.4%', y: '64%', tickX: '5%', tickY: '13%', w: '63%', h: '17%', angle: '-2deg', label: 'b3' }
          ]
        },
        {
          label: 'b1',
          url: './video/b1.mp4',
          options: [
            { x: '4.4%', y: '12%', tickX: '9%', tickY: '16%', w: '53%', h: '15%', angle: '-1deg', label: 'b4' },
            { x: '5.4%', y: '35%', tickX: '6%', tickY: '24%', w: '63%', h: '14%', angle: '-1deg', label: 'b5' },
            { x: '3.4%', y: '60%', tickX: '9%', tickY: '23%', w: '63%', h: '17%', angle: '-1deg', label: 'b6' }
          ]
        },
        {
          label: 'b2',
          url: './video/b2.mp4',
          options: [
            { x: '4.4%', y: '17%', tickX: '7%', tickY: '18%', w: '58%', h: '15%', angle: '-1deg', label: 'b4' },
            { x: '4.4%', y: '40%', tickX: '7%', tickY: '23%', w: '63%', h: '13%', angle: '-1deg', label: 'b5' },
            { x: '4.4%', y: '64%', tickX: '7%', tickY: '20%', w: '63%', h: '18%', angle: '-1deg', label: 'b6' }
          ]
        },
        {
          label: 'b3',
          url: './video/b3.mp4',
          options: [
            { x: '10.4%', y: '19%', tickX: '7%', tickY: '16%', w: '56%', h: '15%', angle: '-1deg', label: 'b4' },
            { x: '10.4%', y: '41%', tickX: '6%', tickY: '26%', w: '56%', h: '14%', angle: '-1deg', label: 'b5' },
            { x: '9.4%', y: '66%', tickX: '6%', tickY: '18%', w: '63%', h: '19%', angle: '-1deg', label: 'b6' }
          ]
        },
        { label: 'b4', url: './video/b4.mp4' },
        { label: 'b5', url: './video/b5.mp4' },
        { label: 'b6', url: './video/b6.mp4' }
      ]
    };
  }

  componentDidMount() {
    this.html = document.documentElement;
    this.body = document.getElementsByTagName('body')[0];
    window.addEventListener('orientationchange', this.handleOrientationChange, false);
    ReactGA.initialize('UA-132973425-1');
    ReactGA.pageview(window.location.pathname + window.location.search);
  }

  componentWillUnmount() {
    window.removeEventListener('orientationchange', this.handleOrientationChange, false);
  }

  componentDidUpdate(prevProps, prevState) {
    const { currentLabel, loaded } = this.state;
    if (loaded) {
      if (prevState.currentLabel !== currentLabel) {
        this.setState({ showOptions: false });
      }
    }
  }

  handleOrientationChange = () => {
    setTimeout(this.setTop, 500);
  };

  setTop = () => {
    console.log('set', this.html.scrollTop);
    this.html.scrollTop = 0;
    this.body.scrollTop = 0;
  };

  handleAllLoad = () => {
    const { videoData } = this.state;

    videoData.forEach(data => {
      const video = this[data.label];
      const buffered = Math.round(video.buffered.end(0)) / Math.round(video.seekable.end(0)) === 1;

      if (buffered) {
        this.total++;
        video.play();
        video.pause();
        video.currentTime = 0;
        console.log('buffered', video, this.total);
      } else {
        video.play();
        video.addEventListener('progress', this.handleVideoLoaded, false);
      }
      if (this.total === videoData.length) {
        this.setState({ loaded: true });
      }
    });
    this.setState({ hasTriggered: true });
  };

  handleVideoLoaded = e => {
    const { videoData } = this.state;
    const video = e.currentTarget;
    console.log('loading', video, video.buffered.end(0), video.seekable.end(0));
    video.pause();
    video.currentTime = 0;
    if (Math.round(video.buffered.end(0)) / Math.round(video.seekable.end(0)) > 0) {
      video.removeEventListener('playing', this.handleVideoLoaded, false);

      this.total++;
      console.log('loaded', video, this.total);
      if (this.total === videoData.length) {
        this.setState({ loaded: true });
      }
    }
  };

  handleProgress = e => {
    const { videoData } = this.state;
    const perc = Math.floor((e.loaded * 100) / e.total);

    if (perc === 100) {
      this.total += perc;
      this.setState({ percent: Math.ceil(this.total / videoData.length) });
    }
  };

  handleVideoComplete = () => {
    const { currentLabel, videoData } = this.state;
    const currData = videoData.find(data => data.label === currentLabel);
    if (currData && currData.options) {
      this.setState({ showOptions: true, ended: true });
    } else {
      this['intro'].seekTo(30);
      this.setState({ showPlayButton: true, ended: true });
    }
  };

  handleVideoPlay = el => {
    const { currentLabel, videoData } = this.state;
    const currData = videoData.find(data => data.label === currentLabel);
    let label = currentLabel;
    // this[label].seekTo(this[label].getDuration() - 2);
    if (currData && currData.options) {
      label = currentLabel;
    } else {
      label = 'intro';
    }

    ReactGA.event({
      category: 'Atiku Question',
      action: `Clicked play ${label}`
    });

    this.setState({ currentLabel: label, showPlayButton: false, paused: false, ended: false });
  };

  handleVideoPause = el => {
    setTimeout(() => {
      const { ended } = this.state;
      if (!ended) {
        this.setState({ showPlayButton: true, paused: true });
      }
    }, 100);
  };

  handleSelect = label => () => {
    this.setState({ currentLabel: label, ended: false });
    // this[label].seekTo(this[label].getDuration() - 2);

    ReactGA.event({
      category: 'Atiku Question',
      action: `Clicked question ${label}`
    });
  };
  render() {
    const { currentLabel, hasTriggered, loaded, paused, showOptions, showPlayButton, videoData } = this.state;
    const currData = videoData.find(data => data.label === currentLabel);

    return (
      <Holder>
        <img className="tick" src="img/tick.png" alt="facebook profile" />
        <Container onClick={!hasTriggered ? this.handleAllLoad : null}>
          {videoData.map((data, i) => {
            // console.log('label', currentLabel, currentLabel === data.label, data.label, loaded);

            return (
              <Video key={`vid-${data.label}`} autoPlay={false} showing={currentLabel === data.label && loaded}>
                <ReactPlayer
                  className="video"
                  onEnded={this.handleVideoComplete}
                  onPause={this.handleVideoPause}
                  ref={el => (this[data.label] = el)}
                  url={data.url}
                  muted={false}
                  playing={currentLabel === data.label && loaded && !paused}
                  playsinline
                  preload
                  style={{ width: '100%', height: '100%' }}
                  volume={1}
                />
              </Video>
            );
          })}
          {showOptions &&
            currData.options &&
            currData.options.map((option, i) => (
              <Tickbox
                key={`${currentLabel}-btn${i}`}
                onClick={this.handleSelect(option.label)}
                x={option.x}
                y={option.y}
                tickX={option.tickX}
                tickY={option.tickY}
                w={option.w}
                h={option.h}
                angle={option.angle}
              />
            ))}
          {loaded && showPlayButton && (
            <Overlay>
              <p>
                This is your chance to ask Atiku a question.
                <br />
                Select a question from the list on <br />
                the notepad in the video.
              </p>
              <Button onClick={this.handleVideoPlay}>
                <img src="img/play.svg" alt="play button" />
              </Button>
            </Overlay>
          )}
        </Container>
        <Message />
        <Footer>
          <ShareContainer>
            <h3>Share: </h3>
            <FacebookShareButton title="Vote Atiku!" url={window.location.href}>
              <FacebookIcon size={32} round />
            </FacebookShareButton>
            <WhatsappShareButton title="Vote Atiku!" url={window.location.href}>
              <WhatsappIcon size={32} round />
            </WhatsappShareButton>
            <TwitterShareButton title="Vote Atiku!" url={window.location.href}>
              <TwitterIcon size={32} round />
            </TwitterShareButton>
          </ShareContainer>
          <div className="title">
            <h1>ASK ATIKU</h1>
            <img className="yourself" src="img/yourself.svg" alt="yourself" />
          </div>
          <img className="pdp-logo" src="img/pdp-logo.png" alt="PDP logo" />
          <img className="rotate" src="img/rotate.svg" alt="rotate svg" />
          <p>
            Rotate your phone
            <br />
            for better experience
          </p>
        </Footer>
      </Holder>
    );
  }
}

export default VideoContainer;
